import { render, staticRenderFns } from "./proofDetail.vue?vue&type=template&id=77a3413c&scoped=true&"
import script from "./proofDetail.vue?vue&type=script&lang=js&"
export * from "./proofDetail.vue?vue&type=script&lang=js&"
import style0 from "./proofDetail.vue?vue&type=style&index=0&id=77a3413c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a3413c",
  null
  
)

export default component.exports